export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";